import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from 'swiper/modules'

import 'swiper/css';

// ! rename the function to align with the widget name
export const homeHero = () => {
    const el = document.querySelector('.curious-home-hero');
    if (!el) return;

    // ------------------------------------------------------------

    const swiper = new Swiper('.hero-slider', {
        modules: [Navigation, Pagination, Autoplay],
        speed: parseInt(el.getAttribute('data-speed')),
        loop: true,
        pagination: {
          el: '.pagination',
          type: "fraction",
        },
        on: {
          slideChange: function() {
            const videos = el.querySelectorAll('video')
            videos.forEach(video => {
              if (video.currentTime > 0) {
                video.pause();
              }
            });
            const currentSlide = this.slides[this.activeIndex];
            const video = currentSlide.querySelector('video');
            if (!video) return;
            if(video.paused) {
              video.currentTime = 0;
              video.play();
            }
          }
        },
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
        autoplay: {
          delay: parseInt(el.getAttribute('data-delay')),
        }
    });

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

